import { addPortNode } from '@/port'
import { h } from '@vue/composition-api'

// @ts-ignore
import SkuPicker from '../components/sku_picker.vue'

export function showSkuPicker(data: { martId: any; goods: any }) {
  const destroy = addPortNode(
    h(
      {
        data: () => ({
          visible: false,
        }),

        mounted() {
          // @ts-ignore
          this.visible = true
        },

        render() {
          return h(SkuPicker, {
            props: {
              value: this.visible,
              ...data,
            },
            on: {
              input: (visible: boolean) => {
                if (!visible) {
                  // @ts-ignore
                  this.visible = false
                  destroy()
                  // setTimeout(destroy, 4000)
                }
              },
            } as any,
          })
        },
      },
      {
        key: Date.now(),
      },
    ),
  )
}
